import React from 'react'
import { createRoot } from 'react-dom/client'

import HorarioList from './edit_dia/horario_list'

document.addEventListener('turbo:load', () => {

  const node = document.getElementById('horario_list');

  if(node) {
    const horarios = JSON.parse(node.getAttribute('data-horarios'));
    const gruposPorHora = JSON.parse(node.getAttribute('data-grupos-por-hora'));

    const root = createRoot(node)

    root.render(
      <HorarioList name="HorarioList" horarios={horarios} gruposPorHora={gruposPorHora} />,
      node,
    )
  }
})
